import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../../helpers';

import { ComponentStyle } from '../../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const Title = styled.h2({
  [mqBreakpoints.desktop]: {
    textAlign: 'center',
  },
});

const Strapline = styled.p({
  fontSize: `${pxToRem(24)} !important`,
  fontWeight: 'var(--font-weight-medium) !important',
  lineHeight: `${pxToRem(32)} !important`,

  [mqBreakpoints.desktop]: {
    textAlign: 'center',
  },
});

type Props = {
  title: string;
  strapline?: string;
  style?: ComponentStyle;
};

export const BenefitsTpHeader: React.FC<Props> = ({ title, strapline, style }) => {
  return (
    <>
      <Title className='display-4' data-testid='mp-product-benefits-title'>
        {title}
      </Title>
      {strapline ? (
        <Strapline className='strapline' data-testid='mp-product-benefits-description'>
          {parseHtml(strapline)}
        </Strapline>
      ) : null}
    </>
  );
};
